import { SelectProps as AntSelectProps, Badge, Form, Select } from "antd"
import EnumSelect from "../../components/form/enumSelect"
import ServerSelectBox from "../../components/serverSelectBox"
import _t from "../../lang/translate"
import { tagsAutoComplete } from "../../services/autocompleteService"
import { useEnums } from "../../services/enumService"
import { EnumItemType } from "../../types/appTypes"
import { TaxLegalCategoryId } from "../../types/taxLegalTypes"

type SelectProps = AntSelectProps<number>


export function PenaltyType(antDesignProps: SelectProps) {
  return (
    <EnumSelect placeholder={_t("choose", "responsibilityEvaluation")} nameKey={["taxLegalCase", "penaltyType"]} {...antDesignProps} />
  )
}

export function LackOfComplianceTags() {
  return (
    <Form.Item noStyle shouldUpdate>
      {({ setFieldsValue }) => (
        <Form.Item label={"Mgl. regelefterlevelse"} name="lackOfComplianceTags">
          <ServerSelectTags categoryId="tax_legal_compliance" placeholder={_t("fix")} updateFieldsValue={(updatedValues) => setFieldsValue({ lackOfComplianceTags: updatedValues })} />
        </Form.Item>
      )}
    </Form.Item>
  )
}
export function PriceSourceTags({ path }: { path: string[] }) {
  return (
    <Form.Item noStyle shouldUpdate>
      {({ setFieldsValue }) => (
        <Form.Item label={_t("equipment", "source")} name={[...path, "equipmentPriceSourceTags"]}>
          <ServerSelectTags categoryId="tax_legal_price_source" placeholder={_t("choose", "source")} updateFieldsValue={(updatedValues) => setFieldsValue({ equipmentSourceTags: updatedValues })} />
        </Form.Item>
      )}
    </Form.Item>
  )
}
export function SelectNewPriceSource({ path }: { path: string[] }) {
  return (
    <Form.Item noStyle shouldUpdate>
      {({ setFieldsValue }) => (
        <Form.Item label={_t("new_price", "source")} name={[...path, "newPriceSourceTag"]}>
          <ServerSelectTags categoryId="tax_legal_price_source" placeholder={_t("choose", "source")} updateFieldsValue={(updatedValues) => setFieldsValue({ newPriceSource: updatedValues })} normalMode />
        </Form.Item>
      )}
    </Form.Item>
  )
}
export function AnalysisTags() {
  return (
    <Form.Item noStyle shouldUpdate>
      {({ setFieldsValue }) => (
        <Form.Item label={_t("analysis")} name="analysisTags">
          <ServerSelectTags categoryId="tax_legal_analysis" placeholder={_t("choose", "analysis")} updateFieldsValue={(updatedValues) => setFieldsValue({ analysisTags: updatedValues })} />
        </Form.Item>
      )}
    </Form.Item>
  )
}

export function ServerSelectTags({ categoryId, updateFieldsValue, placeholder, normalMode, ...rest }:
  { categoryId: TaxLegalCategoryId, updateFieldsValue: (updatedValues: number | number[]) => void, placeholder: string, normalMode?: boolean, }
) {
  return (
    <ServerSelectBox
      allowClear
      // 08-01-2025 --> Remove the ability to add new tags for now. I am keeping the code, just in case we want to use the functionality later.
      // addModalType={"addTag"}
      // addModalExtraValues={{ categoryId }}
      // onItemAdded={(_, updatedValues) => updateFieldsValue(updatedValues)} // TODO: Handle string to number conversion
      apiUrl={tagsAutoComplete()}
      filters={`filter[categoryId]=${categoryId}`}
      placeholder={placeholder}
      mode={normalMode ? undefined : "tags"}
      {...rest}
    />
  )
}

export function OutcomeTypeSelect({ isResumptionConclusion, ...antDesignProps }: SelectProps & { isResumptionConclusion?: boolean }) {
  const filterOutMSMaintains = (data: EnumItemType[]) => data?.filter((item) => item.id !== 7);
  return (
    <EnumSelect placeholder={_t("choose", "outcome")} nameKey={["taxLegalCase", "outcomeType"]}
      dataFilter={isResumptionConclusion ? undefined : filterOutMSMaintains}
      {...antDesignProps}
    />
  )
}

export function ResumptionRequestOutcome(antDesignProps: SelectProps) {
  return (
    <EnumSelect placeholder={_t("choose", "outcome")} nameKey={["taxLegalCase", "resumptionOutcomeType"]} {...antDesignProps} />
  )
}

export function GovernmentAssessmentSelect({ nameSpace, ...rest }: SelectProps & { nameSpace: string }) {
  const [enums] = useEnums()
  const governmentAssessment = enums?.taxLegalCase.governmentAssessment
  return (
    <Select placeholder={_t("choose", "outcome")} {...rest}>
      {governmentAssessment?.map(item => (
        <Select.Option key={item.id} value={item.id}><Badge color={item.color} />{item.title} {nameSpace}</Select.Option>
      ))}
    </Select>
  )
}


